export default __webpack_public_path__ + "static/media/google_G_Logo.e783388b.svg";